import React from 'react';
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { LocalizationProvider, frFR, enUS, zhCN } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TypeTemporality } from './types';
import { RangeDate, SingleDate } from './DateType';
import { selectDatesFilterWrapperStyle, selectDatesSelectorLabelstyle, selectDateFilterStyle, filterDatePaperStyle } from './DatesSelector.style';
import { Z_INDEX_OVERRIDE } from './utils/constants';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
export const DatesSelector = ({ datesRange, dataQa, defaultValue = TypeTemporality.BEFORE, disableFuture, maxDate, minDate, isFormInvalid, setIsFormInvalid, dateTemporality, setDateTemporality, isMobile = false, labelsDateFilter: { subtitle, titleDateBefore, titleDateAfter, titleDateBetween, labelDateDebut, labelDateEnd, labelDate, inputFormat, errorMessageRange, locale }, onChangeRangeDateDebut, onChangeRangeDateEnd, onChangeSingleDate, onReset }) => {
    const handleChange = (event) => {
        const { target: { value } } = event;
        const newTemporality = Object.keys(TypeTemporality)[Object.values(TypeTemporality).indexOf(value)];
        setDateTemporality(TypeTemporality[newTemporality]);
        onReset && onReset();
    };
    let localeText;
    // Allow to translate components texts (for example calendar ..)
    if (locale === 'fr' || locale === 'fr-FR')
        localeText = frFR.components.MuiLocalizationProvider.defaultProps.localeText;
    if (locale === 'zh' || locale === 'zh-CN')
        localeText = zhCN.components.MuiLocalizationProvider.defaultProps.localeText;
    if (locale === 'en' || locale === 'en-US')
        localeText = enUS.components.MuiLocalizationProvider.defaultProps.localeText;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: selectDatesFilterWrapperStyle },
            React.createElement(InputLabel, { id: "dates-selector-label", sx: selectDatesSelectorLabelstyle }, subtitle),
            React.createElement(Select, { "data-qa": `${dataQa}-selectDateRange`, sx: selectDateFilterStyle, labelId: "dates-selector-label", value: dateTemporality, onChange: handleChange, defaultValue: defaultValue, MenuProps: {
                    sx: { zIndex: Z_INDEX_OVERRIDE },
                    PaperProps: {
                        sx: filterDatePaperStyle
                    }
                }, fullWidth: true },
                React.createElement(MenuItem, { value: TypeTemporality.BEFORE, defaultChecked: defaultValue === TypeTemporality.BEFORE }, titleDateBefore),
                React.createElement(MenuItem, { value: TypeTemporality.AFTER, defaultChecked: defaultValue === TypeTemporality.AFTER }, titleDateAfter),
                React.createElement(MenuItem, { value: TypeTemporality.BETWEEN, defaultChecked: defaultValue === TypeTemporality.BETWEEN }, titleDateBetween))),
        React.createElement(LocalizationProvider, { adapterLocale: locale, dateAdapter: AdapterDayjs, localeText: localeText },
            dateTemporality === TypeTemporality.BEFORE &&
                React.createElement(SingleDate, { dataQa: dataQa, disableFuture: disableFuture, filterDates: datesRange, labels: {
                        labelDate: labelDate,
                        inputFormat: inputFormat
                    }, maxDate: maxDate, minDate: minDate, isDateBefore: true, isMobile: isMobile, onChangeSingleDate: onChangeSingleDate, setIsSingleDateInvalid: setIsFormInvalid }),
            dateTemporality === TypeTemporality.AFTER &&
                React.createElement(SingleDate, { dataQa: dataQa, disableFuture: disableFuture, filterDates: datesRange, labels: {
                        labelDate: labelDate,
                        inputFormat: inputFormat
                    }, maxDate: maxDate, minDate: minDate, isDateBefore: false, isMobile: isMobile, onChangeSingleDate: onChangeSingleDate, setIsSingleDateInvalid: setIsFormInvalid }),
            dateTemporality === TypeTemporality.BETWEEN &&
                React.createElement(RangeDate, { dataQa: dataQa, disableFuture: disableFuture, filterDates: datesRange, isDateRangeInvalid: isFormInvalid, setIsDateRangeInvalid: setIsFormInvalid, isMobile: isMobile, labels: {
                        labelDateDebut: labelDateDebut,
                        labelDateEnd: labelDateEnd,
                        inputFormat: inputFormat,
                        errorMessage: errorMessageRange
                    }, maxDate: maxDate, minDate: minDate, onChangeRangeDateDebut: onChangeRangeDateDebut, onChangeRangeDateEnd: onChangeRangeDateEnd }))));
};
